var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.23659 4.9388H5.56576L7.64492 7.02214L7.02409 7.64297L4.94076 5.5638V5.23464L4.82826 5.11797C4.35326 5.5263 3.73659 5.77214 3.06576 5.77214C1.56992 5.77214 0.357422 4.55964 0.357422 3.0638C0.357422 1.56797 1.56992 0.355469 3.06576 0.355469C4.56159 0.355469 5.77409 1.56797 5.77409 3.0638C5.77409 3.73464 5.52826 4.3513 5.11992 4.8263L5.23659 4.9388ZM1.19121 3.06392C1.19121 4.10142 2.02871 4.93892 3.06621 4.93892C4.10371 4.93892 4.94121 4.10142 4.94121 3.06392C4.94121 2.02642 4.10371 1.18892 3.06621 1.18892C2.02871 1.18892 1.19121 2.02642 1.19121 3.06392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoop);
export default __webpack_public_path__ + "static/media/search_loop.8cc463963645b7a7ad1e1547ed405d71.svg";
export { ForwardRef as ReactComponent };